import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';
import css from './SearchPageStyles.module.css';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';

export const MIN_YEAR = 1700;
export const MAX_YEAR = new Date(Date.now()).getFullYear();

const YearFilter = props => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <RangeFilterPlain
      className={css.yearFilter}
      id="yearFilter"
      label={intl.formatMessage({ id: 'Global.yearBuilt' })}
      queryParamNames="year"
      initialValues={{ year: currentQueryParams.year }}
      min={MIN_YEAR}
      max={MAX_YEAR}
      unit=""
      step={1}
      liveEdit
      presets={[[MIN_YEAR, 1990], [1990, 2000], [2000, 2010], [2010, 2020], [2020, MAX_YEAR]]}
      formatNumber={false}
      minLabel={intl.formatMessage({ id: 'Global.from' })}
      maxLabel={intl.formatMessage({ id: 'Global.to' })}
      fromLabel={intl.formatMessage({ id: 'Global.to' })}
      {...props}
    />
  );
};

export default YearFilter;
